// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZUF2Rd8lMIinVsX0 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(185, 185, 185, 0.6);
  backdrop-filter: blur(10px);
  z-index: 9999;
}

.ZUF2Rd8lMIinVsX0 img {
  width: 200px;
  height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".loaderContainer {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgba(185, 185, 185, 0.6);\r\n  backdrop-filter: blur(10px);\r\n  z-index: 9999;\r\n}\r\n\r\n.loaderContainer img {\r\n  width: 200px;\r\n  height: 200px;\r\n}"],"sourceRoot":""}]);
// Exports
export var loaderContainer = `ZUF2Rd8lMIinVsX0`;
export default ___CSS_LOADER_EXPORT___;
